import { langSelector } from './lang-selector';
import { heroAnimation } from './hero-animation';
import {
  registerForm,
  registerSourceForm,
  loginForm,
  requestForm,
  questionForm,
  referralForm,
  conferenceForm,
  forgetForm,
  resetPasswordForm,
  resendVerificationForm,
} from './form-hendler';
import { initPasswordToggle } from './toggle-password';
import { initInputTooltips } from './input-tooltip';
import { initJivoButton } from './jivo';
import { initAnalytics } from './analytics';
import { initCoinsCatalog } from './coins-catalog';
import { initCasesCarousel } from './cases-carousel';
import { initDocumentation } from './documentation';
import { initBlog } from './blog';
import { initIncomeCalculator } from './income-calculator';
import { initGlowAnimation } from './glow-animation';
import { initConferenceBar } from './conference-bar';
import { initHeaderScroll } from './header-scroll';
import { initPaymentDemo } from './payment-demo';

import * as bootstrap from 'bootstrap';

document.addEventListener('DOMContentLoaded', () => {
  // Первым: обработчик кнопки демо не должен зависеть от остальных инициализаций —
  // ошибка в любой из них оставляла кнопку мёртвой до перезагрузки страницы.
  initPaymentDemo();

  langSelector();

  initAnalytics();

  initJivoButton();

  initCoinsCatalog();

  initCasesCarousel();

  initDocumentation();

  initBlog();

  initIncomeCalculator();

  initGlowAnimation();

  initConferenceBar();

  initHeaderScroll();


  registerForm();
  registerSourceForm();
  loginForm();
  requestForm();
  questionForm();
  referralForm();
  conferenceForm();
  forgetForm();
  resetPasswordForm();
  resendVerificationForm();

  // После обработчиков форм: их submit-слушатели ставят was-validated до того,
  // как событие дойдёт до document.
  initInputTooltips();

  initPasswordToggle({
    buttonId: 'togglePasswordLogin',
    inputId: 'loginPassword',
    iconId: 'eyeIconLogin',
  });

  initPasswordToggle({
    buttonId: 'togglePasswordRegister',
    inputId: 'registerPassword',
    iconId: 'eyeIconRegister',
  });

  initPasswordToggle({
    buttonId: 'togglePasswordRegisterRepeat',
    inputId: 'registerPasswordRepeat',
    iconId: 'eyeIconRegisterRepeat',
  });

  initPasswordToggle({
    buttonId: 'togglePasswordReset',
    inputId: 'resetPassword',
    iconId: 'eyeIconReset',
  });

  initPasswordToggle({
    buttonId: 'togglePasswordResetRepeat',
    inputId: 'resetPasswordRepeat',
    iconId: 'eyeIconResetRepeat',
  });

  // Запуск за полэкрана до появления блока: при прокрутке он успевает проявиться до того,
  // как попадёт в кадр, а не проявляется на глазах из пустоты. Показанный блок больше не
  // наблюдаем — класс ставится один раз.
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px 50% 0px' });

  document
    .querySelectorAll('.fade-in-up')
    .forEach((el) => observer.observe(el));

  document.querySelectorAll('.burger-nav a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();

      const targetId = link.getAttribute('href');
      const targetEl = document.querySelector(targetId);

      const offcanvas = bootstrap.Offcanvas.getInstance(
        document.querySelector('#offcanvasBurger'),
      );
      offcanvas?.hide();

      document.querySelector('#offcanvasBurger')?.addEventListener(
        'hidden.bs.offcanvas',
        () => {
          targetEl?.scrollIntoView({ behavior: 'smooth' });
        },
        { once: true },
      );
    });
  });

  const textarea = document.querySelector('textarea');
  const icon = document.querySelector('.textarea-resize-icon');

  if (textarea && icon) {
    let isResizing = false;
    let startY;
    let startH;

    icon.style.pointerEvents = 'auto';
    icon.style.cursor = 'ns-resize';

    icon.addEventListener('mousedown', (e) => {
      isResizing = true;
      startY = e.clientY;
      startH = textarea.offsetHeight;
    });

    document.addEventListener('mousemove', (e) => {
      if (!isResizing) return;
      textarea.style.height = startH + e.clientY - startY + 'px';
    });

    document.addEventListener('mouseup', () => (isResizing = false));

    icon.addEventListener('touchstart', (e) => {
      isResizing = true;
      startY = e.touches[0].clientY;
      startH = textarea.offsetHeight;
    });

    document.addEventListener(
      'touchmove',
      (e) => {
        if (!isResizing) return;
        e.preventDefault();
        textarea.style.height = startH + e.touches[0].clientY - startY + 'px';
      },
      { passive: false },
    );

    document.addEventListener('touchend', () => (isResizing = false));
  }
});

window.addEventListener('load', heroAnimation);
